import React,{useState, useEffect, useCallback} from "react"
import { OrbitProgress } from "react-loading-indicators"
import { readProductsFromDB } from "../services/firebase"
import MainProductSection from "./general/products/main_product_section"
import GeneralProductDesciption from "./general/products/general_products_description"
import ProductCardContainer from "./general/products/products_card_container"

export default function Products(){
    const [products, setProducts] = useState(null)

    useEffect(()=>{
        readProductsFromDB(setProducts)
        
    },[products])
    const containerStyle ={
        display:"flex",
        justifyContent: ' center',
        alignItems: 'center',
    }
    return(
        <>
            <MainProductSection/>
            <GeneralProductDesciption/>
            {
                products?
                <ProductCardContainer products={products}/>:
                <div style={containerStyle}>
                    <OrbitProgress color="#011a39" size="large" text="" textColor="" />
                </div>
            }
        </>
    )
}